var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageRecog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,20H22c-1.105,0-2-0.895-2-2v-7c0-1.105,0.895-2,2-2h20c1.105,0,2,0.895,2,2v7    C44,19.105,43.105,20,42,20z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38,39H26c-1.105,0-2,0.895-2,2v6h16v-6C40,39.895,39.105,39,38,39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,52c0,2.757,2.243,5,5,5h12v4h-4v2h36v-2h-4v-4h12c2.757,0,5-2.243,5-5v-3H1V52z M44,61H20v-4h24    V61z M3,51h58v1c0,1.654-1.346,3-3,3H6c-1.654,0-3-1.346-3-3V51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,16c0-1.654,1.346-3,3-3h7v-2H6c-2.757,0-5,2.243-5,5v31h2V16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,11v2c1.654,0,3,1.346,3,3v31h2V16C63,13.243,60.757,11,58,11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19,33.423 27,31.819 27,29 25,29 25,30.181 17,31.784 17,47 19,47   "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47,47 47,32.221 39,30.219 39,29 37,29 37,31.781 45,33.783 45,47   "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,34v-2h-4c-1.103,0-2,0.897-2,2v8c0,1.103,0.897,2,2,2v3h2v-3h2v-2h-4v-8H15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,47h2v-3c1.103,0,2-0.897,2-2v-8c0-1.103-0.897-2-2-2h-4v2h4v8h-4v2h2V47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.406,20.94C22.712,25.652,27.047,29,32,29s9.288-3.348,10.594-8.06    C43.965,20.663,45,19.451,45,18v-7c0-1.568-1.213-2.844-2.747-2.974C40.621,3.797,36.589,1,32,1s-8.621,2.797-10.253,7.026    C20.213,8.156,19,9.432,19,11v7C19,19.451,20.035,20.663,21.406,20.94z M32,27c-3.841,0-7.225-2.462-8.478-6h16.955    C39.225,24.538,35.841,27,32,27z M32,3c3.478,0,6.566,1.962,8.064,5H23.936C25.434,4.962,28.522,3,32,3z M21,11    c0-0.551,0.448-1,1-1h20c0.552,0,1,0.449,1,1v7c0,0.551-0.448,1-1,1H22c-0.552,0-1-0.449-1-1V11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,17c1.379,0,2.5-1.122,2.5-2.5S28.879,12,27.5,12S25,13.122,25,14.5S26.121,17,27.5,17z     M27.5,14c0.275,0,0.5,0.224,0.5,0.5S27.775,15,27.5,15S27,14.776,27,14.5S27.225,14,27.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,17c1.379,0,2.5-1.122,2.5-2.5S37.879,12,36.5,12S34,13.122,34,14.5S35.121,17,36.5,17z     M36.5,14c0.275,0,0.5,0.224,0.5,0.5S36.775,15,36.5,15S36,14.776,36,14.5S36.225,14,36.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,47v-6c0-1.654-1.346-3-3-3H26c-1.654,0-3,1.346-3,3v6h2v-6c0-0.551,0.448-1,1-1h12    c0.552,0,1,0.449,1,1v6H41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,47h2c0-1.654,1.346-3,3-3s3,1.346,3,3h2c0-2.757-2.243-5-5-5S27,44.243,27,47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47,18.618V6h12v10h-6.764L47,18.618z M49,8v7.382L51.764,14H57V8H49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 4,
    x: 51,
    y: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,30H5V20h6.764L17,17.382V30z M7,28h8v-7.382L12.236,22H7V28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 4,
    x: 9,
    y: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRecog);
export default __webpack_public_path__ + "static/media/image_recog.3b32a8f4498897a1d098fb12ae20e41a.svg";
export { ForwardRef as ReactComponent };